import { Injectable } from '@angular/core';
import { FormConstants } from './form-constants';

declare const MktoForms2: any;

@Injectable({
  providedIn: 'root'
})
export class FormsUtils{

    buildSovosForm(): void{
        MktoForms2.loadForm(FormConstants.sovosFormUrl, FormConstants.sovosAccountId, FormConstants.formsIdByLang.get('pt'));
    }

    getFormIdByLang(): string {
        return FormConstants.sovosFormText.concat(FormConstants.formsIdByLang.get('pt'));
    }
}